import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'megabyteConversionPipe' })
export class MegabyteConversionPipe implements PipeTransform {
  transform(size: number): any {
    var convertedValue = size / 1000000;
    if(convertedValue > 0.1) {
        return convertedValue;
    }
    return "> 0.1";
  }
}
